import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { B2Button, B2Tabs } from "@hdb/biome-2";

import * as _ from "lodash";
import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import ProgressBarModalComponent from "../../../../../core/components/modal/progress-bar-modal.component";
import TableComponent from "../../../../../core/components/table/table.component";

import HasPermission from "../../../../../core/guards/has-permission";

import { getTownCouncils } from "../../../../../store/slices/town-council.slice";

import "../inventory.scss";

import AssetUploadModal from "./asset-upload-modal.component";

import {
  excelFileTypes,
  validateExcelFile,
} from "src/shared/helpers/validate-Files";
import axiosInstanceAssetRevamp from "src/core/api/axiosClientSave";

const AssetImportRevampComponent = ({ }) => {
  const [isAssetModalOpen, setIsAssetModalOpen] = useState<boolean>(false);

  const [progress, setProgress] = useState<number>(0);
  const [showProgressModal, setShowProgressModal] = useState<boolean>(false);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getTownCouncils({ PageNumber: 0, pageSize: 0 }));
  }, [dispatch]);

  const selectedItems = useSelector((state: any) => state.table.selectedItems);

  const handleCloseModal = (isRefetchRequired: boolean) => {
    setIsAssetModalOpen(false);

    setFileUploadResponse([]);
    setEditableRows([]);
  };

  const emptyConfig = {
    title: "No Asset Found",
    description: "",
  };

  const [tempFileUploadResponse, setTempFileUploadResponse] = useState([]);
  const [fileUploadResponse, setFileUploadResponse] = useState([] as any);
  const [editableRows, setEditableRows] = useState([] as any);
  const [tempEditableRows, setTempEditableRows] = useState([] as any);
  const [editableDeviceCodes, setEditableDeviceCodes] = useState([] as any);
  // const [isValidation, setIsValidation] = useState<any>(true);
  const [file, setFile] = useState(null as any);
  const [modalNumberOfRecords, setmodalNumberOfRecords] = useState(0);
  const [modalPage, setModalPage] = useState(1);
  const [modalPageForEditable, setModalPageForEditable] = useState(1);
  const [activeAssetErrorTab, setActiveAssetErrorTab] =
    useState("Assetswitherror");
  const modalPageSize = 5;

  const paginate = (array: [], page_size: any, page_number: any) => {
    const data = array.slice(
      (page_number - 1) * page_size,
      page_number * page_size
    );
    return data;
  };

  useEffect(() => {
    const data = paginate(fileUploadResponse, modalPageSize, modalPage);
    setTempFileUploadResponse(data);
  }, [modalPage]);

  useEffect(() => {
    const data = paginate(editableRows, modalPageSize, modalPageForEditable);
    setTempEditableRows(data);
  }, [modalPageForEditable]);

  const confirmAssetsFromErrorResults = async () => {
    setProgress(0);

    try {
      const selectedItemsData = selectedItems.filter((item: any) => item.value);
      const formData = new FormData();
      formData.append("file", file);
      formData.append("isValidation", "false");
      for (let item of selectedItemsData) {
        formData.append("deviceCodesForUpdate[]", item.value);
      }

      await axiosInstanceAssetRevamp
        .post(`/slpapp/Asset/saveAssetRevamp`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            const { loaded, total } = progressEvent;
            if (total !== null && total !== undefined) {
              const percentCompleted = Math.round((loaded * 100) / total);
              setProgress(percentCompleted);
            }
          },
        })
        .then(() => {
          setIsAssetModalOpen(false);
          document.body.classList.remove("loading-indicator");

          dispatch({
            type: "table/toggleSelectAll",
            payload: [],
          });

          dispatch({
            type: "table/toggleSelect",
            payload: { page: null, value: null, status: null },
          });

          setActiveAssetErrorTab("Assetswitherror");
        })
        .catch((error: any) => {
          setProgress(0);
          console.log("error uploading file: ", error);
        });
    } catch (error) {
      setProgress(0);
      console.error("Error uploading file:", error);
      throw error;
    }
  };

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];

      const isValid = await validateExcelFile(file);
      if (!isValid) return false;

      setFile(file);
      setProgress(0);

      try {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("isValidation", "true");

        await axiosInstanceAssetRevamp
          .post(`/slpapp/Asset/saveAssetRevamp`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: (progressEvent) => {
              const { loaded, total } = progressEvent;
              if (total !== null && total !== undefined) {
                const percentCompleted = Math.round((loaded * 100) / total);
                setProgress(percentCompleted);
              }
            },
          })
          .then((response: any) => {
            if (response?.data?.data?.assetUploadValidationDetails?.length) {
              // setIsValidation(false);

              setFileUploadResponse(
                _.cloneDeep(response?.data?.data?.assetUploadValidationDetails)
              );

              setEditableDeviceCodes(
                _.cloneDeep(response?.data?.data?.updateableDeviceCode)
              );

              const data = paginate(
                response?.data?.data?.assetUploadValidationDetails,
                modalPageSize,
                modalPage
              );

              setTempFileUploadResponse(data);

              setmodalNumberOfRecords(response?.data?.numberOfRecords);

              setIsAssetModalOpen(true);

              setTimeout(() => {
                if (document.body.classList.contains("loading-indicator")) {
                  document.body.classList.remove("loading-indicator");
                }
              }, 500);
            } else {
              handleCloseModal(true);

              setTimeout(() => {
                if (document.body.classList.contains("loading-indicator")) {
                  document.body.classList.remove("loading-indicator");
                }
              }, 500);
            }
          })
          .catch((error: any) => {
            setProgress(0);
            console.log("error uploading file: ", error);
          });
      } catch (error) {
        setProgress(0);
        console.error("Error uploading file:", error);
        throw error;
      }
    }

    event.target.value = "";
  };

  useEffect(() => {
    if (fileUploadResponse.length && editableDeviceCodes.length) {
      const editableRows = fileUploadResponse.filter((row: any) =>
        editableDeviceCodes.find((asset: any) => asset === row.assetCode)
      );
      setEditableRows(editableRows);
      setTempEditableRows(editableRows);

      const data = paginate(editableRows, modalPageSize, modalPageForEditable);

      setTempEditableRows(data);
    }
  }, [fileUploadResponse]);

  useEffect(() => {
    if (progress > 0 && progress < 100) {
      setShowProgressModal(true);
    } else if (progress == 100) {
      setShowProgressModal(true);

      setTimeout(() => {
        setShowProgressModal(false);
        document.body.classList.add("loading-indicator");
      }, 500);
    } else {
      setShowProgressModal(false);
    }
  }, [progress]);

  const onModalPageChange = (page: number) => {
    setModalPage(page);
  };

  const onModalPageChangeForEditable = (page: number) => {
    setModalPageForEditable(page);
  };

  const onModalSortChange = (sortBy: string, sortDirection: any) => {
    // console.log("sortBy", sortBy, "sortDirection", sortDirection);
  };

  const [modalColumns] = useState([
    {
      title: "Asset",
      label: "assetCode",
      isSorted: true,
    },
    {
      title: "Message",
      label: "message",
    },
  ]);

  return (
    <div>
      <div className="d-flex gap-3 justify-content-center table-generic-action mt-5">
        <HasPermission
          moduleName="Asset"
          actionName="Upload-Asset"
          isRoute={false}
        >
          <div className="d-flex justify-content-end table-generic-action ">
            <B2Button className="icon-text-btn" variant="primary">
              <FontAwesomeIcon icon={faUpload} className="" />
              <label htmlFor="upload" className="ms-2 cursor-pointer">
                Import Asset
                {" "}
                <input
                  accept={excelFileTypes}
                  id="upload"
                  type="file"
                  className="d-none"
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    handleFileChange(event);
                  }}
                />
              </label>
            </B2Button>
          </div>
        </HasPermission>
      </div>

      {isAssetModalOpen && (
        <AssetUploadModal
          showModal={isAssetModalOpen}
          handleClose={() => handleCloseModal(true)}
        >
          <div className="ms-3 d-block">
            <div>
              <div style={{ fontSize: "18px", fontWeight: "700" }}>
                <div style={{ marginTop: "1rem", marginBottom: "1rem" }}>
                  Asset error details
                </div>
                {activeAssetErrorTab === "Editableassetsfromtheerrorlist" && (
                  <div style={{ marginTop: "1rem", marginBottom: "1rem" }}>
                    Select Assets and click save to continue uploading
                  </div>
                )}
              </div>
            </div>
            {selectedItems?.length > 1 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
                className="my-3"
              >
                <B2Button
                  variant="primary"
                  onClick={() => {
                    confirmAssetsFromErrorResults();
                  }}
                >
                  Save
                </B2Button>
              </div>
            )}
          </div>

          <div className="custom_tab_start">
            <B2Tabs
              activeKey={activeAssetErrorTab}
              pills
              tabClassName={""}
              onSelect={(selectedId: any) => {
                setActiveAssetErrorTab(selectedId);
              }}
              tab={[
                {
                  content: (
                    <div>
                      {!!tempFileUploadResponse?.length && (
                        <TableComponent
                          tableHeaders={modalColumns}
                          emptyConfig={emptyConfig}
                          data={tempFileUploadResponse}
                          totalNumberOfRecords={modalNumberOfRecords}
                          pageSize={modalPageSize}
                          current={modalPage}
                          onChangePage={onModalPageChange}
                          onChangeSort={onModalSortChange}
                        />
                      )}
                    </div>
                  ),
                  id: "Assetswitherror",
                  title: "Assets with error",
                },
                ...(tempEditableRows.length > 0
                  ? [
                    {
                      content: (
                        <div>
                          {!!tempEditableRows?.length && (
                            <TableComponent
                              tableHeaders={modalColumns}
                              emptyConfig={emptyConfig}
                              allData={editableRows}
                              data={tempEditableRows}
                              totalNumberOfRecords={modalNumberOfRecords}
                              pageSize={modalPageSize}
                              current={modalPageForEditable}
                              onChangePage={onModalPageChangeForEditable}
                              onChangeSort={onModalSortChange}
                              enableSelection={true}
                            />
                          )}
                        </div>
                      ),
                      id: "Editableassetsfromtheerrorlist",
                      title: "Update assets from the error list",
                    },
                  ]
                  : []),
              ]}
            />
          </div>
        </AssetUploadModal>
      )}
      {showProgressModal && (
        <ProgressBarModalComponent
          showModal={showProgressModal}
          progress={progress}
        />
      )}
    </div>
  );
};

export default AssetImportRevampComponent;
